import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import './Navbar.css';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('hero');

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
      
      // Detect active section
      const sections = ['hero', 'about', 'treatments', 'gallery', 'contact'];
      const scrollPosition = window.scrollY + 100; // offset for navbar height
      
      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i]);
        if (section && section.offsetTop <= scrollPosition) {
          setActiveSection(sections[i]);
          break;
        }
      }
    };
    
    handleScroll(); // Initial check
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const handleBookAppointment = () => {
    window.open('https://clinicia.com/calendar/book?u=75835', '_blank');
  };

  return (
    <nav className={`navbar ${isScrolled ? 'navbar-scrolled' : ''}`}>
      <div className="container">
        <div className="navbar-content">
          <div className="navbar-logo" onClick={() => scrollToSection('hero')}>
            <img
              src={`${process.env.PUBLIC_URL}/images/vibedental-logo4.png`}
              alt="Vibe Dental Studio"
              className="logo-image"
            />
          </div>

          <div className={`navbar-menu ${isMobileMenuOpen ? 'mobile-menu-open' : ''}`}>
            <a onClick={() => scrollToSection('hero')} className={`navbar-link ${activeSection === 'hero' ? 'active' : ''}`}>Home</a>
            <a onClick={() => scrollToSection('about')} className={`navbar-link ${activeSection === 'about' ? 'active' : ''}`}>About</a>
            <a onClick={() => scrollToSection('treatments')} className={`navbar-link ${activeSection === 'treatments' ? 'active' : ''}`}>Treatments</a>
            <a onClick={() => scrollToSection('gallery')} className={`navbar-link ${activeSection === 'gallery' ? 'active' : ''}`}>Gallery</a>
            <a onClick={() => scrollToSection('contact')} className={`navbar-link ${activeSection === 'contact' ? 'active' : ''}`}>Contact</a>
          </div>

          <button className="btn-primary navbar-cta" onClick={handleBookAppointment}>
            Book Appointment
          </button>

          <button 
            className="mobile-menu-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;